import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { authSlice } from '@starjack/features/authentication';
import { notificationSlice } from '@/slices/notificationSlice';

export const authMiddleware: Middleware = (api) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
        const payload = action.payload as
            | { status?: number; errors?: Array<{ error?: string }> }
            | undefined;
        if (payload?.status == 401) {
            api.dispatch(
                authSlice.actions.clearAuthData({
                    userLogout: false,
                })
            );
            const error = payload?.errors?.[0];
            if (error?.error !== 'token_expired') {
                api.dispatch(
                    notificationSlice.actions.addNotification({
                        type: 'error',
                        message: 'Fehler beim Laden der Daten.',
                    })
                );
            }
            return;
        }
    }

    return next(action);
};
